import React from 'react';
import NotificationOccurrenceListPageContainer from './NotificationOccurrenceListPageContainer';

export class NotificationOccurrenceListPage extends React.Component{
    
    render(){
      return (
        <NotificationOccurrenceListPageContainer {...this.props}/>
      )
    }
}